import React from "react"
import { Col } from "react-bootstrap"

const EstateVisualItem = ({ item, onClick }) => {
  return (
    <Col className="no-padding wiz-container" xs="12" sm="12" md="6" lg="6">
      <div className={`wiz-img ${item.divClass || ""}`}>
        <img
          onClick={() => onClick(item.imgLarge || item.img)}
          src={item.img}
          alt={item.alt || item.title || " "}
          className={item.imgClass ?? null}
          style={item.imgStyle ?? null}
        />
      </div>
      <div className="wiz-text">
        {item.title && <h3>{item.title}&nbsp;</h3>}
        <p dangerouslySetInnerHTML={{ __html: item.text }} />
      </div>
    </Col>
  )
}

export default EstateVisualItem
